import { routerPostCall } from '../../axios';

const signIn = (state, params) => {
  const url = `/auth/signin`;
  return routerPostCall(state, url, params);
};
export default { signIn };
